const { defineMessages } = require('@sm/intl');

const COPY = defineMessages({
  SELECT: {
    id: 'Pricing.PackageCta.Select',
    defaultMessage: 'SELECT',
    desc: '[Type: Button][Vis.: high] - A button/link text for an authenticated user',
  },
  SIGN_UP: {
    id: 'Pricing.PackageCta.SignUp',
    defaultMessage: 'SIGN UP',
    desc: '[Type: Button][Vis.: high] - A button/link text for an unauthenticated user',
  },
  YOUR_PLAN: {
    id: 'Pricing.PackageCta.YourPlan',
    defaultMessage: 'YOUR PLAN',
    desc: '[Type: Button][Vis.: high] - A button/link text for an  purchased user',
  },
  CONTACT_US: {
    id: 'Pricing.PackageCta.ContactUs',
    defaultMessage: 'CONTACT US',
    desc: '[Type: Button][Vis.: high] - A button/link text to contact the sales team',
  },
});

export default COPY;
